import React, { useEffect, useState } from 'react';
import './CSS/Local.css'; // Import the updated CSS file
// import './CSS/Global.css';
import Header from './Header';
import Footer from './Footer';
import { toast } from 'react-toastify';
import Select from 'react-select';

const InquiryForm = () => {
  // State to manage form data
  const fullUrl = window.location.href;
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    parentName: '',
    school: '',
    dob: '',
    remark: '', // Removed skatedCategory from state,
    classname: "",
    dob: "Website"
  });
  const [services, setServices] = useState([]);
  const [load, setLoad] = useState(true);
  const [classname, setclassname] = useState([]);
  const [error, setError] = useState("");
  const [isHumanChecked, setIsHumanChecked] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [checkboxErrors, setCheckboxErrors] = useState({
    isHuman: false,
    terms: false,
  });


  const fetchCenter = async () => {
    try {
      const response = await fetch(`https://100billionrealestate.com/centerlist/admin1997`)
      let res = await response.json();
      console.log(res);
      setclassname(res)
    } catch (error) {
      console.log(error)
    }
  }

  const activeClass = classname.filter(center_name => center_name.status === 'Active');

  const options2 = activeClass.map(language => ({
    value: language.center_name,
    label: (`${language.center_name}`),
  }));


  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value.trim(); // Remove leading and trailing spaces

    if (name === "mobile") {
      updatedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 10); // Allow only numbers and limit to 10 digits

      // Remove leading zero
      if (updatedValue.startsWith("0")) {
        updatedValue = updatedValue.slice(1);
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    // Validation for phone number
    if (name === "mobile") {
      if (value.startsWith("0")) {
        setError("");
      } else if (updatedValue.length < 10) {
        setError("Phone number must be 10 digits long");
      } else {
        setError("");
      }
    }
  };


  console.log(formData)
  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isHumanChecked || !agreedToTerms) {
      setCheckboxErrors({
        isHuman: !isHumanChecked,
        terms: !agreedToTerms,
      });
      return;
    }
    setLoad(false)
    console.log('Form data submitted:', formData);
    // You can add form submission logic here
    try {
      const response = await fetch(`https://100billionrealestate.com/inquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          mobile: formData.mobile,
          parent_name: formData.parentName,
          school: formData.school,
          dob: formData.dob,
          age: formData.classname,
          remark: formData.remark,
          skates_category: fullUrl,
          dob: "Website"
        })
      })
       if (response.ok) {
                      toast.success("Thank you! Our team will contact you soon.", {
                          position: "top-center",
                          autoClose: 10000, // Close toast after 3 seconds
                      });

        setFormData({
          name: "",
          mobile: "",
          parent_name: "",
          school: "",
          email: "",
          age: "",
          remark: "",
          skates_category: ""
        })
        setIsHumanChecked(false)
        setAgreedToTerms(false)
      }
      setLoad(true)
    } catch (error) {
      console.log(error)
      setLoad(true)
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'black',
      color: 'white',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      color: 'black',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'black',
    }),
    input: (provided) => ({
      ...provided,
      color: 'rgb(37, 37, 37)',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'black',
      color: 'white',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#414040' : 'black',
      color: 'white',
      ':hover': {
        backgroundColor: '#e8e8e8',
        color: 'black',
      },
    }),
  };

  console.log(formData)

  const servicesAllFetch = async () => {
    try {
      const response = await fetch(`https://100billionrealestate.com/centerlist/100billiontechservice`)
      const res = await response.json();
      console.log(res);
      const extractedServices = res.map(item => item.center_name);
      setServices(extractedServices);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchCenter();
    servicesAllFetch();
  }, [])
  return (
    <>


      <div className="inquiry-form-container">
        <h2>Enquiry</h2>
        <form onSubmit={handleSubmit}>
          <div className="inquiry-form-step">
            <div className="inquiry-input-group">
              <label htmlFor="name">Your Name</label>
              <div className="inquiry-input-wrapper">
                <i className="fa fa-user inquiry-input-icon"></i>
                <input
                  id="name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter Name"
                  required
                />
              </div>
            </div>

            <div className="inquiry-input-group">
              <label htmlFor="parentName">Mobile</label>
              <div className="inquiry-input-wrapper">
                <i className="fa fa-user-group inquiry-input-icon"></i>
                <input
                  id="parentName"
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter Mobile"
                  required
                />
              </div>
              {error && <p className="error-message-form error-service-message">{error}</p>}
            </div>
            <div className="inquiry-input-group">
              <label htmlFor="dob">Select Service</label>
              <div className="inquiry-input-wrapper">
                <i className="fas fa-wrench inquiry-input-icon"></i>
                <select id='school' name="classname" value={formData.classname} onChange={handleChange} required>
                  <option value="">Select Service</option>
                  {
                    services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                </select>
              </div>
            </div>

          </div>

          <div className="inquiry-input-group">
            <label htmlFor="remark">Message</label>
            <div className="inquiry-input-wrapper">
              <i class="fa-solid fa-comments inquiry-input-icon textarea"></i>

              <textarea
                id="remark"
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                placeholder="Enter Message"
                className="inquiry-form-textarea"
                rows="5"  // Adjust height
                cols="50" // Adjust width
              ></textarea>

            </div>
          </div>
          {/* <div className="four-servicepagemainweb-page"> */}
            <div className="form-mainfieldcheck-hbt">
              <div className="form-fieldcheck-hbt">
                <input
                  type="checkbox"
                  id="isHuman"
                  checked={isHumanChecked}
                  onChange={(e) => {
                    setIsHumanChecked(e.target.checked);
                    setCheckboxErrors((prev) => ({ ...prev, isHuman: false }));
                  }}
                />

                <p className="form-terms-hbt">Please check the box to confirm you're human</p>



              </div>
              {checkboxErrors.isHuman && <p className="error-message-form">Please confirm you're human</p>}
              <div className="form-fieldcheck-hbt">
                <input
                  type="checkbox"
                  id="terms"
                  checked={agreedToTerms}
                  onChange={(e) => {
                    setAgreedToTerms(e.target.checked);
                    setCheckboxErrors((prev) => ({ ...prev, terms: false }));
                  }}
                />
                <p className="form-terms-hbt">By submitting, you agree to our <span onClick={() => window.open("https://100billiontech.com/terms-and-conditions", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer", color: "#4685f6" }}>terms and conditions</span></p>


              </div>
              {checkboxErrors.terms && <p className="error-message-form">You must agree to the terms</p>}
            </div>
          {/* </div> */}

          {
            load ? <button type="submit" className="inquiry-submit-btn">Submit</button> :
              <button type="button" className="inquiry-submit-btn">Loading...</button>
          }
        </form>
      </div>
    </>
  );
};

export default InquiryForm;
